import BaseListStore from 'stores/BaseListStore';
import RuleStore from 'stores/rule/RuleStore';
import { IDataFetchOptions } from '../../types';
import { get } from 'stores/_services/dataService';
import { SortDirection } from 'constants/SortDirection';

export default class RuleVersionListStore extends BaseListStore<RuleStore> {
    constructor() {
        super({
            itemStore: RuleStore
        });
    }

    async getRuleVersions({ ruleId, ...args }: IDataFetchOptions & { ruleId: string }): Promise<void> {
        this._updateListState(args);

        const options = {
            filter: {
                order: this.sortBy === 'author' ? null : this.sort,
                include: [
                    {
                        relation: 'author',
                        scope: {
                            fields: ['email']
                        }
                    }
                ]
            }
        };

        const { data } = await get(`rules/${ruleId}/versions`, options);

        this.clearIds();

        this._updateData(data);
        this._updateIds(data);

        if (this.sortBy === 'author') {
            const dir = this.sortDirection === SortDirection.ASC ? 1 : -1;

            this.ids.sort((a, b) => {
                const aData = this.data.get(a);
                const bData = this.data.get(b);

                return aData.author > bData.author ? dir : -dir;
            });
        }
    }

    async getRuleVersion(ruleVersionId: string) {
        const options = {
            filter: {
                include: [
                    {
                        relation: 'author',
                        scope: {
                            fields: ['email']
                        }
                    }
                ]
            }
        };

        const { data } = await get(`ruleVersions/${ruleVersionId}/detail`, options);

        this._updateData(data);
    }
}
